<div class="post-container">    
    <div class="navigation-content">
        <h4 routerLink="/categories"><< powrót do kategorii</h4>
    </div>    
</div>

<div class="post-container">    
    <div class="post-title post-title-yellow">
        <h2>Niebyleczo, czyli język od kuchni</h2>
    </div>
</div>

<div class="post-container">
    <div class="post-content page-content">
        <p class="dfont center">
            Wspólne gotowanie i jedzenie bardzo łączy, ale jest też wyjątkowo słowotwórcze. Spotykamy się wokół stołu, 
            spędzamy wspólnie czas, przygotowując potrawy świąteczne i ulubione dania. Przywołaj historie związane 
            ze wspólnym gotowaniem, niedzielnym obiadem, ulubionymi lub znienawidzonymi potrawami.
        </p>
    </div>    

    <div class="post-content page-image">
        <img src="../../assets/game03/policjant.png" />
    </div>

    <div class="post-content page-content">
        <p class="dfont center">
            Jako inspirację wykorzystaj potrawy i składniki, które powstały w domach uczestniczek i uczestników naszego 
            programu. Możesz ich użyć w swoim menu, przeciągając je w odpowiednie miejsca.
        </p>
    </div>    
</div>


<div class="post-container">
    <div class="post-content page-content page-chooses" cdkDropListGroup>
        <div class="choose-options">
            <div cdkDropList 
                cdkDropListSortingDisabled
                *ngFor="let item of items; let i = index"
                class="option-item"
                [id]="'item-'+i"
                [cdkDropListData]="item">
                <div class="box"
                    cdkDrag 
                    [cdkDragData]="item">
                    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                    <img src="{{ item.image }}" alt="" />
                </div> 
            </div>   
        </div>   
        <div class="choose-wrapper"             
            (click)="textarea.focus()"
            cdkDropList
            (cdkDropListDropped)="drop($event)">
            <textarea #textarea [(ngModel)]='jadlospis'></textarea>
        </div>                      
        
    </div>
</div>



<div class="post-container">
    <div class="post-content" style="text-align: right; margin-top: 50px;">
        <button class="dark jadlospis" (click)="getPdf();">Pobierz jadłospis doMowy</button>
        <button class="dark"
            [routerLink]="['/task', taskId]">
            Przejdź dalej >>
        </button>
    </div>        
</div>
